/**
 * QUEM RECEBE O ESC: SÓ A CAMADA DE CIMA.
 *
 * A gaveta (`ui/navegacao.tsx`), o modal e a lista do `SelectField` ouviam o
 * Esc no `document`, cada um por conta própria. Com um modal aberto sobre a
 * gaveta do negócio (ex.: "Marcar como perdido"), um Esc fechava os dois - e
 * com a lista de motivos aberta, fechava os três. A gaveta se inscreveu
 * primeiro, então nem `stopPropagation` no modal chegaria a tempo.
 *
 * Aqui modal e lista se empilham numa pilha só, ouvida na fase de CAPTURA do
 * `document` (que roda antes de qualquer ouvinte comum dele): o Esc vai para
 * quem abriu por último e para ali. Sem nada empilhado, o ouvinte nem existe,
 * e a gaveta sozinha continua fechando no Esc como antes.
 */
const pilhaDoEsc: Array<() => void> = [];

function aoEsc(e: KeyboardEvent) {
  if (e.key !== 'Escape') return;
  const topo = pilhaDoEsc[pilhaDoEsc.length - 1];
  if (!topo) return;
  e.stopPropagation();
  topo();
}

export function empilharEsc(fechar: () => void) {
  if (typeof document === 'undefined') return () => {};
  pilhaDoEsc.push(fechar);
  if (pilhaDoEsc.length === 1) document.addEventListener('keydown', aoEsc, true);
  return () => {
    const i = pilhaDoEsc.lastIndexOf(fechar);
    if (i >= 0) pilhaDoEsc.splice(i, 1);
    if (pilhaDoEsc.length === 0) document.removeEventListener('keydown', aoEsc, true);
  };
}
